import _ from 'lodash/fp'
import { all, call, put, take, takeLatest } from 'redux-saga/effects'

import { types, actions } from '../reducers/organisations'
import { getEffect, postEffect } from './network'
import { PATH_GRAPHQL_HTTP } from '../config'

//  ███████╗███████╗███████╗███████╗ ██████╗████████╗███████╗
//  ██╔════╝██╔════╝██╔════╝██╔════╝██╔════╝╚══██╔══╝██╔════╝
//  █████╗  █████╗  █████╗  █████╗  ██║        ██║   ███████╗
//  ██╔══╝  ██╔══╝  ██╔══╝  ██╔══╝  ██║        ██║   ╚════██║
//  ███████╗██║     ██║     ███████╗╚██████╗   ██║   ███████║
//  ╚══════╝╚═╝     ╚═╝     ╚══════╝ ╚═════╝   ╚═╝   ╚══════╝

export function * loadOrganisationsEffect () {
  const request = {
    url: 'organizations' // who the f**k spells it with a z
  }

  const chan = yield call(getEffect, request)
  return yield take(chan)
}

function * submitReviewEffect ({ oauthKey, reviewId, unionId }) {
  const request = {
    url: `${PATH_GRAPHQL_HTTP}/review/submit`,
    options: {
      body: {
        reviewId,
        oauthKey,
        unionId
      }
    }
  }

  const chan = yield call(postEffect, request)
  return yield take(chan)
}

//  ███████╗ █████╗  ██████╗  █████╗ ███████╗
//  ██╔════╝██╔══██╗██╔════╝ ██╔══██╗██╔════╝
//  ███████╗███████║██║  ███╗███████║███████╗
//  ╚════██║██╔══██║██║   ██║██╔══██║╚════██║
//  ███████║██║  ██║╚██████╔╝██║  ██║███████║
//  ╚══════╝╚═╝  ╚═╝ ╚═════╝ ╚═╝  ╚═╝╚══════╝

export function * loadOrganisationsFlow () {
  const orgs = yield call(loadOrganisationsEffect)

  if (orgs.error) {
    yield put(actions.loadError(orgs))
  } else {
    yield put(actions.loadSuccess(_.keyBy('id', orgs)))
  }

  yield put(actions.loadRequestDone())
}

function * submitReviewFlow ({ payload }) {
  const { oauthKey, reviewId, unionId } = payload
  if (!oauthKey || !reviewId || !unionId) {
    yield put(
      actions.submitReviewError({
        message: `missing parameters for submit reviewId:${reviewId}, oauthKey:${oauthKey}, unionId:${unionId}`
      })
    )
  } else {
    const response = yield call(submitReviewEffect, {
      oauthKey,
      reviewId,
      unionId
    })

    if (response.error) {
      yield put(
        actions.submitReviewError(
          _.getOr('Unknown Error', 'body', response.error)
        )
      )
    } else {
      yield put(actions.submitReviewSuccess())
    }
  }
}

export default function * () {
  return yield all([
    takeLatest(types.LOAD_REQUEST, loadOrganisationsFlow),
    takeLatest(types.SUBMIT_REVIEW, submitReviewFlow)
  ])
}
